import * as t from 'io-ts';

export const TokenDynamicType = t.interface({
    access_token: t.string,
    refresh_token: t.string
});

export type Token = t.TypeOf<typeof TokenDynamicType>;
